import * as React from 'react';
import { inject, observer } from 'mobx-react';

// Components
import { UitkPageLoader } from 'uitk-react-loader';
import { UIPageStore } from 'stores/ui-page-store';

export interface AnimatedProgressIndicatorProps {
  uiPage?: UIPageStore;
}

@inject('page', 'uiPage')
@observer
export class AnimatedProgressIndicator extends React.Component<AnimatedProgressIndicatorProps> {
  public componentWillUnmount() {
    this.props.uiPage.hideProgressIndicator();
  }

  public render() {
    const { uiPage } = this.props;

    return <UitkPageLoader visible={uiPage && uiPage.displayProgressIndicator} />;
  }
}
